import { Pencil, Trash2 } from "lucide-react";

const HEADERS = [
  "Service",
  "Language Pair",
  "Specialization",
  "Currency",
  "Unit",
  "Price/Unit",
  "Actions",
];

const PriceListTable = ({ data, onEdit, onDelete, readOnly = false }) => {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table className="w-full table-auto border-collapse min-w-[900px]">
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  No price list found.
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                const langPair =
                  item.languagePair?.sourceLanguage && item.languagePair?.targetLanguage
                    ? `${item.languagePair.sourceLanguage.code} → ${item.languagePair.targetLanguage.code}`
                    : "—";
                return (
                  <tr
                    key={item.id}
                    className={`${rowBg} hover:bg-blue-50 transition-colors`}
                  >
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {item.service?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {langPair}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.specialization?.name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.currency?.currency?.code || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {item.unit || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900 font-medium">
                      {item.price_per_unit ?? "—"}
                    </td>
                    <td className="px-3 py-2 text-center whitespace-nowrap">
                      {readOnly ? (
                        <span className="text-[10px] text-gray-400">—</span>
                      ) : (
                        <div className="flex justify-center gap-3">
                          <Pencil
                            className="w-4 h-4 text-blue-400 hover:text-blue-600 cursor-pointer transition-colors"
                            title="Edit"
                            onClick={() => onEdit?.(item)}
                          />
                          <Trash2
                            className="w-4 h-4 text-red-400 hover:text-red-600 cursor-pointer transition-colors"
                            title="Delete"
                            onClick={() => onDelete?.(item)}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PriceListTable;
